import { canUseDOM } from '../helpers/dom';

// window.model3d appears once the lazy model3d chunk evaluates. Its api was
// already a no-op before the model finished loading, so treating an absent
// bridge as a no-op matches the pre-split behavior exactly.
export const model3dChangeStep = step => {
  if (canUseDOM()) window.model3d?.api.changeStep(step);
};

export const model3dSetTexture = (...args) =>
  canUseDOM() && window.model3d ? window.model3d.api.setTexture(...args) : Promise.resolve();
